module.exports = __webpack_public_path__ + "static/media/B61915-RECEIV_2.64874139.PDF";